/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface BootstrapFieldPermissionsRequest {
    sessionId?: string;
}

export interface DemonstrateFieldPermissionsRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface GetFieldLevelRolesRequest {
    sessionId?: string;
}

export interface GetRoleFieldPermissions1Request {
    roleName: string;
    sessionId?: string;
}

export interface GetUserFieldPermissions1Request {
    sessionId?: string;
}

/**
 * FieldLevelPermissionsApi - interface
 * 
 * @export
 * @interface FieldLevelPermissionsApiInterface
 */
export interface FieldLevelPermissionsApiInterface {
    /**
     * Bootstraps field-level permissions and roles for a tenant. This creates predefined roles with granular field access control.  **Available Roles:** - **CASE_NOTE_TAKER**: Can only add notes to cases - **CASE_STATUS_UPDATER**: Can only update case status and severity - **CASE_ASSIGNMENT_MANAGER**: Can assign cases and update status - **CASE_ESCALATION_MANAGER**: Can escalate cases and update status - **CASE_BASIC_EDITOR**: Can update basic fields and add notes - **CASE_FULL_EDITOR**: Can update all case fields - **USER_BASIC_MANAGER**: Can update basic user information - **USER_CONTACT_MANAGER**: Can update user contact information - **USER_FULL_MANAGER**: Can update all user fields  **Field Groups:** - **basic**: name, summary (for cases); firstName, lastName, email (for users) - **status**: status, severity (cases only) - **notes**: summary field (for storing notes) - **assignment**: owner (cases only) - **escalation**: escalated (cases only) - **correlation**: correlationGroup, correlationMetadata (cases only) - **custom**: customFields (cases only) - **contact**: phone, department (users only) - **preferences**: timezone, language (users only) 
     * @summary Bootstrap field-level permissions
     * @param {string} [sessionId] Session ID for tenant isolation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldLevelPermissionsApiInterface
     */
    bootstrapFieldPermissionsRaw(requestParameters: BootstrapFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Bootstraps field-level permissions and roles for a tenant. This creates predefined roles with granular field access control.  **Available Roles:** - **CASE_NOTE_TAKER**: Can only add notes to cases - **CASE_STATUS_UPDATER**: Can only update case status and severity - **CASE_ASSIGNMENT_MANAGER**: Can assign cases and update status - **CASE_ESCALATION_MANAGER**: Can escalate cases and update status - **CASE_BASIC_EDITOR**: Can update basic fields and add notes - **CASE_FULL_EDITOR**: Can update all case fields - **USER_BASIC_MANAGER**: Can update basic user information - **USER_CONTACT_MANAGER**: Can update user contact information - **USER_FULL_MANAGER**: Can update all user fields  **Field Groups:** - **basic**: name, summary (for cases); firstName, lastName, email (for users) - **status**: status, severity (cases only) - **notes**: summary field (for storing notes) - **assignment**: owner (cases only) - **escalation**: escalated (cases only) - **correlation**: correlationGroup, correlationMetadata (cases only) - **custom**: customFields (cases only) - **contact**: phone, department (users only) - **preferences**: timezone, language (users only) 
     * Bootstrap field-level permissions
     */
    bootstrapFieldPermissions(requestParameters: BootstrapFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Demonstrates how field-level permissions filter request payloads. This endpoint shows which fields would be allowed/denied for the current user.  **Example Usage:** - Send a case update request with various fields - The response shows which fields are permitted and which are filtered out - This helps understand how field-level permissions work in practice 
     * @summary Demonstrate field-level permission filtering
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for tenant isolation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldLevelPermissionsApiInterface
     */
    demonstrateFieldPermissionsRaw(requestParameters: DemonstrateFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Demonstrates how field-level permissions filter request payloads. This endpoint shows which fields would be allowed/denied for the current user.  **Example Usage:** - Send a case update request with various fields - The response shows which fields are permitted and which are filtered out - This helps understand how field-level permissions work in practice 
     * Demonstrate field-level permission filtering
     */
    demonstrateFieldPermissions(requestParameters: DemonstrateFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves a list of available field-level roles that can be assigned to users. These roles provide granular access control to specific fields within resources. 
     * @summary Get available field-level roles
     * @param {string} [sessionId] Session ID for tenant isolation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldLevelPermissionsApiInterface
     */
    getFieldLevelRolesRaw(requestParameters: GetFieldLevelRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Retrieves a list of available field-level roles that can be assigned to users. These roles provide granular access control to specific fields within resources. 
     * Get available field-level roles
     */
    getFieldLevelRoles(requestParameters: GetFieldLevelRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves the specific field-level permissions associated with a role. This shows which fields a user with this role can access and modify. 
     * @summary Get field-level permissions for a role
     * @param {string} roleName Role name to get permissions for
     * @param {string} [sessionId] Session ID for tenant isolation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldLevelPermissionsApiInterface
     */
    getRoleFieldPermissions1Raw(requestParameters: GetRoleFieldPermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Retrieves the specific field-level permissions associated with a role. This shows which fields a user with this role can access and modify. 
     * Get field-level permissions for a role
     */
    getRoleFieldPermissions1(requestParameters: GetRoleFieldPermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves the field-level permissions for the current user in the specified tenant. This shows which fields the user can access and modify based on their assigned roles. 
     * @summary Get user\'s field-level permissions
     * @param {string} [sessionId] Session ID for tenant isolation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldLevelPermissionsApiInterface
     */
    getUserFieldPermissions1Raw(requestParameters: GetUserFieldPermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Retrieves the field-level permissions for the current user in the specified tenant. This shows which fields the user can access and modify based on their assigned roles. 
     * Get user\'s field-level permissions
     */
    getUserFieldPermissions1(requestParameters: GetUserFieldPermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class FieldLevelPermissionsApi extends runtime.BaseAPI implements FieldLevelPermissionsApiInterface {

    /**
     * Bootstraps field-level permissions and roles for a tenant. This creates predefined roles with granular field access control.  **Available Roles:** - **CASE_NOTE_TAKER**: Can only add notes to cases - **CASE_STATUS_UPDATER**: Can only update case status and severity - **CASE_ASSIGNMENT_MANAGER**: Can assign cases and update status - **CASE_ESCALATION_MANAGER**: Can escalate cases and update status - **CASE_BASIC_EDITOR**: Can update basic fields and add notes - **CASE_FULL_EDITOR**: Can update all case fields - **USER_BASIC_MANAGER**: Can update basic user information - **USER_CONTACT_MANAGER**: Can update user contact information - **USER_FULL_MANAGER**: Can update all user fields  **Field Groups:** - **basic**: name, summary (for cases); firstName, lastName, email (for users) - **status**: status, severity (cases only) - **notes**: summary field (for storing notes) - **assignment**: owner (cases only) - **escalation**: escalated (cases only) - **correlation**: correlationGroup, correlationMetadata (cases only) - **custom**: customFields (cases only) - **contact**: phone, department (users only) - **preferences**: timezone, language (users only) 
     * Bootstrap field-level permissions
     */
    async bootstrapFieldPermissionsRaw(requestParameters: BootstrapFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/field-permissions/bootstrap`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Bootstraps field-level permissions and roles for a tenant. This creates predefined roles with granular field access control.  **Available Roles:** - **CASE_NOTE_TAKER**: Can only add notes to cases - **CASE_STATUS_UPDATER**: Can only update case status and severity - **CASE_ASSIGNMENT_MANAGER**: Can assign cases and update status - **CASE_ESCALATION_MANAGER**: Can escalate cases and update status - **CASE_BASIC_EDITOR**: Can update basic fields and add notes - **CASE_FULL_EDITOR**: Can update all case fields - **USER_BASIC_MANAGER**: Can update basic user information - **USER_CONTACT_MANAGER**: Can update user contact information - **USER_FULL_MANAGER**: Can update all user fields  **Field Groups:** - **basic**: name, summary (for cases); firstName, lastName, email (for users) - **status**: status, severity (cases only) - **notes**: summary field (for storing notes) - **assignment**: owner (cases only) - **escalation**: escalated (cases only) - **correlation**: correlationGroup, correlationMetadata (cases only) - **custom**: customFields (cases only) - **contact**: phone, department (users only) - **preferences**: timezone, language (users only) 
     * Bootstrap field-level permissions
     */
    async bootstrapFieldPermissions(requestParameters: BootstrapFieldPermissionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bootstrapFieldPermissionsRaw(requestParameters, initOverrides);
    }

    /**
     * Demonstrates how field-level permissions filter request payloads. This endpoint shows which fields would be allowed/denied for the current user.  **Example Usage:** - Send a case update request with various fields - The response shows which fields are permitted and which are filtered out - This helps understand how field-level permissions work in practice 
     * Demonstrate field-level permission filtering
     */
    async demonstrateFieldPermissionsRaw(requestParameters: DemonstrateFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling demonstrateFieldPermissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/field-permissions/demonstrate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Demonstrates how field-level permissions filter request payloads. This endpoint shows which fields would be allowed/denied for the current user.  **Example Usage:** - Send a case update request with various fields - The response shows which fields are permitted and which are filtered out - This helps understand how field-level permissions work in practice 
     * Demonstrate field-level permission filtering
     */
    async demonstrateFieldPermissions(requestParameters: DemonstrateFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.demonstrateFieldPermissionsRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a list of available field-level roles that can be assigned to users. These roles provide granular access control to specific fields within resources. 
     * Get available field-level roles
     */
    async getFieldLevelRolesRaw(requestParameters: GetFieldLevelRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/field-permissions/roles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retrieves a list of available field-level roles that can be assigned to users. These roles provide granular access control to specific fields within resources. 
     * Get available field-level roles
     */
    async getFieldLevelRoles(requestParameters: GetFieldLevelRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getFieldLevelRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the specific field-level permissions associated with a role. This shows which fields a user with this role can access and modify. 
     * Get field-level permissions for a role
     */
    async getRoleFieldPermissions1Raw(requestParameters: GetRoleFieldPermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['roleName'] == null) {
            throw new runtime.RequiredError(
                'roleName',
                'Required parameter "roleName" was null or undefined when calling getRoleFieldPermissions1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/field-permissions/roles/{roleName}/permissions`;
        urlPath = urlPath.replace(`{${"roleName"}}`, encodeURIComponent(String(requestParameters['roleName'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retrieves the specific field-level permissions associated with a role. This shows which fields a user with this role can access and modify. 
     * Get field-level permissions for a role
     */
    async getRoleFieldPermissions1(requestParameters: GetRoleFieldPermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getRoleFieldPermissions1Raw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the field-level permissions for the current user in the specified tenant. This shows which fields the user can access and modify based on their assigned roles. 
     * Get user\'s field-level permissions
     */
    async getUserFieldPermissions1Raw(requestParameters: GetUserFieldPermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/field-permissions/user/permissions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retrieves the field-level permissions for the current user in the specified tenant. This shows which fields the user can access and modify based on their assigned roles. 
     * Get user\'s field-level permissions
     */
    async getUserFieldPermissions1(requestParameters: GetUserFieldPermissions1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getUserFieldPermissions1Raw(requestParameters, initOverrides);
    }

}
